import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';

const url = `${PREFIX_URL}/legal-center/privacy-policy`;

type UpdatePrivacyPolicyResponse = { status: boolean };

export const updatePrivacyPolicy = ({
  content,
}: {
  content: string;
}): Promise<UpdatePrivacyPolicyResponse> => {
  return axios.post(url, { content }, { showError: false });
};

type UseUpdatePrivacyPolicyOptions = {
  config?: MutationConfig<typeof updatePrivacyPolicy>;
};

export const useUpdatePrivacyPolicy = ({ config }: UseUpdatePrivacyPolicyOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: ({ content }) => updatePrivacyPolicy({ content }),
  });
};
